import { render, staticRenderFns } from "./quiz.vue?vue&type=template&id=30f22ee1&scoped=true&lang=pug&"
import script from "./quiz.vue?vue&type=script&lang=js&"
export * from "./quiz.vue?vue&type=script&lang=js&"
import style0 from "./quiz.vue?vue&type=style&index=0&id=30f22ee1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f22ee1",
  null
  
)

component.options.__file = "quiz.vue"
export default component.exports